import { ApiUrlPrepare } from "@lib/helpers/ApiHelper";
import { API } from "@lib/services/http";
import { ApiParams, PaginationType } from "@lib/types";
import { AILog } from "@lib/types/AILog";

export const apiGetAILogs = async <T extends ApiParams>(params: T) => {
  const url = ApiUrlPrepare({ params, url: `/ai-log` });
  return API.get<PaginationType<AILog>>(url);
};
